import React from "react";
import IconLink from "./IconLink";
import { SavedIcon as SavedIconComponent } from "./icons";

export interface SavedIconProps {
  className?: string;
  "data-testid"?: string;
  onSavedClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  brand?: string;
  notification?: string;
}

const SavedIcon: React.FC<SavedIconProps> = ({
  className = "",
  "data-testid": dataTestId = "header-saveditems-icon",
  onSavedClick,
  brand = "very",
  notification,
}) => {
  return (
    <IconLink
      href="/saveditems.page"
      icon={<SavedIconComponent />}
      label="Saved"
      onClick={onSavedClick}
      data-testid={dataTestId}
      ariaLabel="Saved Items"
      className={`${className} saved-items`}
      notification={notification}
    />
  );
};

export default SavedIcon;
